import React, { useEffect, useContext, useRef, useState } from 'react';
import { Container, Col, Row } from 'reactstrap';
import styles from './NJRLanding.module.css';
import { ReactComponent as RefrigeratorIcon } from '../../assets/images/refrigerator.svg';
import { ReactComponent as RangeIcon } from '../../assets/images/range.svg';
import { ReactComponent as WasherIcon } from '../../assets/images/washer.svg';
import { ReactComponent as ElectricalIcon } from '../../assets/images/electrical.svg';
import { ReactComponent as CheckmarkIcon } from '../../assets/images/checkmark.svg';
import { useHistory } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import BuildPlan from './BuildPlanSection/BuildPlan';
import classNames from 'classnames';
import Accordion from '../shared/AccordionCard/Accordion';
import { dataLayerPush } from '../../helpers';
import { usePageTitle } from '../_ReactHooks';
import { SalesContext } from '../contexts/SalesContext';
import { ReactComponent as Phone } from '../../assets/images/Vendor/NJR/phone.svg';
import { BrandingContext } from '../contexts/ContractContext';
import getClientContent from '../_BrandingProvider/brandContent';
import { stripPhoneNumber } from '../shared/util';
import PlanBenefitsModal from '../modals/PlanBenefits/PlanBenefitsModal';
import { ReactComponent as PlayButton } from '../../assets/images/Vendor/NJR/play-video.svg';
import HeroDesktop from '../../assets/images/Vendor/NJR/hero-desktop.png';
import HeroTablet from '../../assets/images/Vendor/NJR/hero-tablet.png';
import HeroMobile from '../../assets/images/Vendor/NJR/hero-mobile.png';

const assets = {
    refrigerator: {
        icon: <RefrigeratorIcon />,
        title: 'Refrigerator',
        repair: 'Evaporator',
        avgCost: '$690'
    },
    range: {
        icon: <RangeIcon />,
        title: 'Range',
        repair: 'Thermostat',
        avgCost: '$406'
    },
    electrical: {
        icon: <ElectricalIcon />,
        title: 'Electrical',
        repair: 'Bathroom Exhaust Fan',
        avgCost: '$355'
    },
    washer: {
        icon: <WasherIcon />,
        title: 'Washer',
        repair: 'Pump',
        avgCost: '$341'
    }
};

const resetContext = {
    planData: {
        activeAddPlans: [],
        activePlan: null,
        additionalTotal: 0,
        plan: 'monthly',
        planTotal: 0,
        selectedAddPlans: [],
        selectedPlan: {}
    },
    formData: {
        invitationNumber: '0',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        serviceAddress: {
            address1: '',
            address2: '',
            city: '',
            state: 'NJ',
            zip: '',
            stateId: 39
        },
        mailingAddress: {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            stateId: ''
        },
        billingAddress: {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            stateId: ''
        },
        doNotSolicit: null,
        serviceAsMailingAddress: true,
        billingAsServiceAddress: true
    },
    termsAndCondition: false,
    promocodeObj: null,
    isPromoApplied: false
};

const HoverCard = ({ index, hasFooter }) => {
    console.log(index, hasFooter);
    const asset = assets[index];
    return (
        <div className={styles.hoverCard}>
            <span
                aria-describedby={index}
                tabindex={0}
            >
                {asset.icon}
            </span>
            <div
                className={styles.hoverContent}
                role='tooltip'
                id={index}
                aria-live='polite'
            >
                <div className={styles.hoverContentIcon}>{asset.icon}</div>
                <h3>{asset.title}</h3>
                <p className={styles.repair}>Potential Repair: {asset.repair}</p>
                <div className={styles.cost}>
                    <p>
                        Sample Repair Cost<sup>1</sup>
                    </p>
                    <h3 className='h1'>{asset.avgCost}</h3>
                </div>
                {hasFooter && (
                    <div className={styles.reimbursement}>
                        <span className={styles.checkIcon}>
                            <CheckmarkIcon />
                        </span>
                        <p className='mb-0'>Up to $250 in food spoilage reimbursement</p>
                    </div>
                )}
            </div>
        </div>
    );
};

const ServicePlanCards = () => {
    const serviceAssests = Object.keys(assets);
    return (
        <Row>
            {serviceAssests.map((el) => {
                const asset = assets[el];
                return (
                    <Col
                        key={el}
                        className={`p-2 mb-4`}
                        lg='3'
                        md='6'
                        sm='6'
                        xs='6'
                    >
                        <div className={styles.serviceCardContent}>
                            <div className={styles.seviceCardIconSection}>
                                <div className={styles.serviceCardIcon}>{asset.icon}</div>
                                <h5 className='mb-0'>{asset.title}</h5>
                                <p className={styles.serviceRepair}>Potential Repair: {asset.repair}</p>
                            </div>
                            <div className={styles.serviceCost}>
                                <p className='mb-0 mt-2'>Average Repair Cost</p>
                                <h4 className='mb-2'>{asset.avgCost}</h4>
                            </div>
                        </div>
                    </Col>
                );
            })}
        </Row>
    );
};

const AccordionCard = ({ index }) => {
    const asset = assets[index];
    return (
        <div className={styles.accordionAns}>
            <div className={styles.accordionContentIcon}>{asset.icon}</div>
            <h3>{asset.title}</h3>
            <p className={styles.repair}>Potential Repair: {asset.repair}</p>
            <div className={styles.cost}>
                <p>
                    Average Repair Cost<sup>1</sup>
                </p>
                <h3 className='h1'>{asset.avgCost}</h3>
            </div>
        </div>
    );
};

const NJRLanding = () => {
    usePageTitle('Home');

    const context = useContext(SalesContext);
    const videoEl = useRef(null);
    const [tsf, SetLowerTsf] = useState([]);

    useEffect(() => {
        // Clearing cache
        context.updatePlanData(resetContext.planData);
        context.updateFormData(resetContext.formData);
        dataLayerPush('Pageview', {
            pagePath: '/',
            pageTitle: 'NJR Retail Service Plans - Home'
        });
        fetch(`api/pricing/RiskProfile/GetByMasterProgramId/20/16/${'njr'}`)
            .then((res) => res.json())
            .then((data) => {
                var lowerTsfValue = data[0].tsf;
                const lsfValue = Math.min(...lowerTsfValue);
                SetLowerTsf(lsfValue);
            });
    }, []);

    const isMobile = useMediaQuery({ maxWidth: '767px' });
    const isTablet = useMediaQuery({ minWidth: '768px', maxWidth: '1023px' });
    const isDesktop = useMediaQuery({ minWidth: '1024px' });
    const isDesktopFP = useMediaQuery({ minWidth: '1243px' });
    const isTabletFP = useMediaQuery({ minWidth: '768px', maxWidth: '1242px' });
    const branding = useContext(BrandingContext);
    const clientId = branding.contract || 'NJR';
    const { variableText } = getClientContent(clientId);
    const phoneNumber = variableText.customerService.phone;
    const [showPlanBenefitModal, setShowPlanBenefitModal] = useState(false);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    const history = useHistory();

    const handleRoute = () => {
        context.updatePlanData(resetContext.planData);
        context.updateFormData(resetContext.formData);

        const sessionAgent = sessionStorage.getItem('isAgentEntry');

        let isAgent = history.location.search.includes('agent=true') || sessionAgent;

        console.log(sessionAgent);
        console.log(isAgent, history, history.location);

        context.updateIsAgent(isAgent);
        sessionStorage.setItem('isAgentEntry', isAgent);

        history.push('/shopplan');
    };

    const getAnswer = (key) => {
        return <AccordionCard index={key} />;
    };

    const getAccordion = (key) => (
        <Accordion
            key={key}
            question={assets[key].title}
            answer={getAnswer(key)}
            noBodyPadding={true}
        />
    );

    const servicePlanBenefits = () => {
        const servicePlanInfo = [
            'Protection for mechanical and electrical failures',
            'Covers your appliances regardless of their age',
            'Protects your budget from expensive repairs',
            `Choose your service fee (as low as $${tsf} per claim)`
        ];
        return servicePlanInfo.map((benefit, index) => {
            return (
                <div>
                    <div>
                        <CheckmarkIcon />
                    </div>
                    <div>{benefit}</div>
                </div>
            );
        });
    };

    const handleVideoClick = () => {
        if (videoEl.current.paused) {
            videoEl.current.play();
            setIsVideoPlaying(true);
        } else {
            videoEl.current.pause();
            setIsVideoPlaying(false);
        }
    };

    return (
        <Container className='p-0'>
            <div className={styles.njrHero}>
                <div className={styles.heroText}>
                    <div>
                        <div className={styles.helpContact}>
                            <div className={styles.helpContactContent}>
                                <div className={styles.serviceIcon}>
                                    <Phone />
                                </div>
                                <div className={styles.helpPhoneText}>
                                    <div>Need Help?</div>
                                    <div>
                                        Call{' '}
                                        <a
                                            href={`tel:${stripPhoneNumber(phoneNumber)}`}
                                            aria-label='Customer service phone number'
                                            className=' font-weight-bold callLink'
                                        >
                                            {phoneNumber}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h1>Protect the Products You Use Every Day</h1>
                        <p>
                            Our plans can help eliminate the stress of home breakdowns, reducing impact to your budget
                            and everyday routine.
                        </p>
                    </div>
                    <button
                        id='shopBtnHero'
                        aria-label='click to open build a plan screen'
                        className={classNames('btn-primary', styles.btnPlan)}
                        onClick={handleRoute}
                    >
                        View Plans
                    </button>
                </div>
                <div className={styles.heroImg}>
                    {isDesktop && (
                        <img
                            src={HeroDesktop}
                            role='presentation'
                        />
                    )}
                    {isTablet && (
                        <img
                            src={HeroTablet}
                            role='presentation'
                        />
                    )}
                    {isMobile && (
                        <img
                            src={HeroMobile}
                            role='presentation'
                        />
                    )}
                </div>
            </div>
            <div className={styles.saveCard}>
                <div className={styles.secCardTitle}>
                    <h1>How Much Can a Service Plan Save You?</h1>
                    <p>
                        A plan could pay for itself with your first repair! Plan costs are usually less expensive than
                        one repair. Typical repair costs are indicated below.<sup>1</sup>
                    </p>
                    {isDesktopFP && <ServicePlanCards />}
                    {(isMobile || isTabletFP) && (
                        <>
                            {Object.keys(assets).map(getAccordion)}
                            <div className={`${styles.shopBtn} mb-4 mt-2`}>
                                <button
                                    id='shopBtnBtm'
                                    aria-label='click to open build a plan screen'
                                    className='btn btn-primary'
                                    onClick={handleRoute}
                                >
                                    View Plans
                                </button>
                            </div>
                        </>
                    )}
                    <p className={styles.disclaimer}>
                        <sup>1</sup>These savings are estimates only and no amount of repair is guaranteed. The sample
                        repair cost is based on a sample of labor and part cost using national data and/or N.J. data.
                        Your actual repair savings may be less depending on such factors as geographic location, actual
                        incident, contractor rates and type of appliance.
                    </p>
                    {isDesktopFP && (
                        <div className={`${styles.shopBtn} mb-3`}>
                            <button
                                id='shopBtnBtm'
                                aria-label='click to open build a plan screen'
                                className='btn btn-primary'
                                onClick={handleRoute}
                            >
                                View Plans
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div className={`${styles.servicePlanBenefitsSection} mb-3`}>
                <div className={styles.servicePlanVideoContent}>
                    <div
                        className={styles.videoPlayControls}
                        onClick={handleVideoClick}
                    >
                        {!isVideoPlaying && <PlayButton className={styles.playButton} />}
                    </div>
                    <video
                        onClick={handleVideoClick}
                        onEnded={() => setIsVideoPlaying(false)}
                        ref={videoEl}
                        id='njrVideo'
                        src={'/Videos/NJR_WARRANTY_SPOT.mp4'}
                    />
                    <div className={styles.videoCaptions}>Sometimes unexpected is nice; other times it's not.</div>
                </div>
                <div className={styles.servicePlanBenefitsContent}>
                    <div className='mt-2'>SERVICE PLAN BENEFITS</div>
                    <h2>
                        Plans Provide Reliable <br /> Coverage Benefits.
                    </h2>
                    <button
                        className={`btnLink`}
                        aria-label='click to open service plan benefits modal'
                        onClick={() => setShowPlanBenefitModal(true)}
                    >
                        View All Benefits
                    </button>
                    <div className={`mt-4 ${styles.serviceBenefits}`}>{servicePlanBenefits()}</div>
                </div>
            </div>
            <BuildPlan />
            <div className={styles.saveCard}>
                <div className={`${styles.shopBtn} mb-3`}>
                    <button
                        id='shopBtnBtm'
                        aria-label='click to open build a plan screen'
                        className='btn btn-primary'
                        onClick={handleRoute}
                    >
                        Shop Plans
                    </button>
                </div>
                <div className={styles.questionsContact}>
                    <div>
                        Questions? Call{' '}
                        <a
                            href={`tel:${stripPhoneNumber(phoneNumber)}`}
                            aria-label='Customer service phone number'
                            className='font-weight-bold callLink'
                        >
                            {phoneNumber}
                        </a>
                    </div>
                </div>
            </div>
            {showPlanBenefitModal && (
                <PlanBenefitsModal
                    isOpen={showPlanBenefitModal}
                    centered={true}
                    toggle={() => setShowPlanBenefitModal(!showPlanBenefitModal)}
                />
            )}
        </Container>
    );
};

export default NJRLanding;
